export default __webpack_public_path__ + "24d13557f41203e65f23ec6f0e2d5451.svg";